<template>
  <div>
    <div
      class="dropdown-menu remove-style"
      aria-labelledby="dropdownMenuButton"
    >
      <a class="dropdown-item" style="cursor:pointer" :disabled="selectedProducts.length < 1" @click="selectedBulkAction='Delete Product';productActionChanged()">Delete Product</a>
      <a class="dropdown-item" style="cursor:pointer" :disabled="selectedProducts.length < 1" @click="selectedBulkAction='Create Guardrail';productActionChanged()">Create Guardrail</a>
    </div>
    <ProductListDeleteConfirmModal
      heading="Delete Products"
      @deleteSelectedProducts="deleteSelectedProducts"
      @closeDeleteConfirmModal="closeDeleteConfirmModal"
    ></ProductListDeleteConfirmModal>
  </div>
</template>

<script>
import ProductListDeleteConfirmModal from "@/components/product/ProductListDeleteConfirmModal";

export default {
  name: "AsinScrapperAction",
  data() {
    return {
      selectedBulkAction: "Action",
      delLoader: false,
    };
  },
  components: {
    ProductListDeleteConfirmModal,
  },
  computed: {
    selectedProducts: {
      set(val) {
        this.$store.state.product.selectedProducts = val;
      },
      get() {
        return this.$store.state.product.selectedProducts;
      },
    },
  },
  methods: {
    productActionChanged() {
      if (this.selectedBulkAction == "Delete Product") {
        $("#confirmDeleteProduct").modal("show");
      } else if (this.selectedBulkAction == "Create Guardrail") {
        let path = '/addEditGuardrail/' + 'null' + '/myAutomation' + '/asin'
        this.$router.push({ path: path });
      }
    },
    deleteSelectedProducts() {
      //	this.delLoader = true;
      let vm = this;
      this.$emit("showLoader");
      this.$store
        .dispatch("asinScapper/deleteProducts", this.selectedProducts)
        .then((res) => {
          vm.$store.state.product.selectedProducts = [];
          this.$store.state.product.actionSelectionControl = false;
          (vm.selectedBulkAction = "Action"),
            //vm.delLoader = false;
            this.$emit("getList");
        });
    },
    closeDeleteConfirmModal() {
      this.selectedProducts = [];
      this.selectedBulkAction = "Action";
      this.$store.state.product.actionSelectionControl = false;
      $("#confirmDeleteProduct").modal("hide");
      this.$emit("resetSelected");
    },
  },
};
</script>

<style lang="scss">
</style>
